import {AbstractDiscoStandardMapper} from "../abstract-disco-standard.mapper";

export class FrDiscoFonSynthesisMapper extends AbstractDiscoStandardMapper {
}
